//File to display report details of the selected features and option to generate reports to PDF or Excel
//npm install jspdf jspdf-autotble xlsx
import React, { useState, useEffect } from 'react';
import { Grid, Box, Button, useTheme, Typography, ThemeProvider, } from '@mui/material';
import getTheme from '../../theme/theme';
import { Backdrop, CircularProgress, } from "@mui/material";
import BasicTable, { Column } from '../../components/table';
import logo from '../../assets/logo/brix logo1.png';

import { Link } from 'react-router-dom';
import { ARROW, } from "../../constants/Common"
import { ReportDetails, ReportInputData } from './CreateReport';
import { useNavigate, useLocation } from "react-router-dom";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';


const ReportView = () => {
    const [reportDetails, setReportDetails] = useState<ReportDetails[]>([]);
    const [selReport, setSelReport] = useState<ReportInputData>();
    const navigate = useNavigate();
    const theme = useTheme();
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const report_heading = "BrixPro Report";

    useEffect(() => {
        displayReport();
    }, []);


    const displayReport = () => {
        let argReportInput = location?.state?.report_input;
        let argReportDetails = location?.state?.report_details;
        if (argReportDetails !== undefined) {
            setReportDetails(argReportDetails);
            setSelReport(argReportInput);
        }
    }

    const columns: Column[] = [
        { id: 'featurename', label: 'Feature Name', align: 'left' },
        { id: 'projectname', label: 'Project Name', align: 'left' },        
        { id: 'title', label: 'Title', align: 'left' },
        { id: 'status', label: 'Status', align: 'left' },
        { id: 'createdby', label: 'Created By', align: 'left' },
        { id: 'createddate', label: 'Created On', align: 'left' },
    ];


    const selectedColumns = columns.filter(column => 
        selReport?.columns.includes(column.label) 
    );

    
    const rowsReportDetails = reportDetails.map((report, index) => ({
        featurename: report.featurename,
        projectname: report.projectname,
        title: report.title,
        status: report.status,
        createdby: report.createdby,
        createddate: report.createddate,
    }));

    const tableHeaders = selectedColumns.map(column => column.label);


    // Function to split text into lines of a specific width
    function splitTextIntoLines(text: string, maxWidth: number, doc: jsPDF): string[] {
        const words = text.split(' ');
        const lines: string[] = [];
        let currentLine = '';
    
        words.forEach(word => {
            const testLine = currentLine + word + ' ';
            const testWidth = doc.getTextWidth(testLine);
    
            if (testWidth > maxWidth) {
                lines.push(currentLine.trim());
                currentLine = word + ' ';
            } else {
                currentLine = testLine;
            }
        });
    
        lines.push(currentLine.trim()); // Add the last line
        return lines;
    }
    
        

    const handleDescFormatting = (description:string) => {
        if (!description) return '';
    
        const maxLength = 150;
        let formattedDescription = '';
        let currentLine = '';
    
        for (let count = 0; count < description.length; count++) {
          const char = description[count];
          currentLine += char;
    
          if (currentLine.length > maxLength) {
            formattedDescription += `${currentLine.trim()}\n`; // Add a newline
            currentLine = '';
          }
        }
    
        // Add the remaining line (if any)
        formattedDescription += currentLine.trim();
        return formattedDescription;
      };
    
    const handleExportExcel = () => {
        //Function to generate Excel sheet
        const worksheet = XLSX.utils.json_to_sheet([]); // Start with an empty sheet 

        XLSX.utils.sheet_add_aoa(worksheet, [[report_heading]], { origin: 'A1' });
        worksheet['A1'].s = { font: { bold: true } }; // Set bold font for the title

        const headerLine1 = [`Report Title:`, `${selReport?.title}`, `Created By:`, `${selReport?.createdby}`];
        const headerLine2 = [`Project :`, `${selReport?.project_name}`, `Created Date:`, `${selReport?.createddate}`];
        const headerLine3 = [`Report Descripton:`, `${selReport?.description}`];

        // Add header line to the worksheet
        XLSX.utils.sheet_add_aoa(worksheet, [headerLine1], { origin: 'A3' });
        XLSX.utils.sheet_add_aoa(worksheet, [headerLine2], { origin: 'A4' });
        XLSX.utils.sheet_add_aoa(worksheet, [headerLine3], { origin: 'A5' });

        // Add column titles to the worksheet
        XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: 'A7' });
        XLSX.utils.sheet_add_json(worksheet, rowsReportDetails, { origin: 'A8', skipHeader: true });

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Report Data');
        
        // Write workbook to binary string then to array buffer
        const binaryString = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
        const buffer = new ArrayBuffer(binaryString.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < binaryString.length; i++) {
            view[i] = binaryString.charCodeAt(i) & 0xFF;
        }

        // Create Blob from buffer and save blob to file
        const blobWithType = new Blob([view], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blobWithType, 'Report.xlsx');

    }


    const handleExportPDF = () => {
        //Function to generate PDF file
        const doc = new jsPDF();
        const fontname = 'helvetica';
        const docWidth = doc.internal.pageSize.getWidth();

        // Calculate the center position for the title
        const titleX = (docWidth - doc.getStringUnitWidth(report_heading)) / 2;
        const logoWidth = 36;  // Desired width of the logo
        const logoHeight = 15;  // Desired height of the logo
        
        // Add the logo image to the document
        doc.addImage(logo, 'PNG', 12, 12, logoWidth, logoHeight);
        
        // Add title of the report
        doc.setFontSize(16);
        doc.text(report_heading, titleX - 15, 20);

        doc.setDrawColor(0,0,0); //black colour border
        doc.setLineWidth(1); // Set border width as 1
        const margin = 10; // Define border margins
        // Draw the page border (top, right, bottom, left)
        doc.rect(margin, margin, doc.internal.pageSize.getWidth() - margin * 2, doc.internal.pageSize.getHeight() - margin * 2, 'S'); // Stroke (outline)
        

        let firstRow = 40
        let pdfRow = firstRow
        doc.setFontSize(12);
        doc.setFont(fontname, 'bold')
        doc.text(`Report Title : `, 20, firstRow);
        doc.setFont(fontname, 'normal')
        let wid = doc.getTextWidth(`Report Title: `);
       // doc.text(`${selReport?.title + ""}`, wid + 30, firstRow);

        const lines_title = doc.splitTextToSize(selReport?.title+"", 60);
        const lineHeight = 5; // Adjust this value to set the distance between the lines
        // Add each line of title to the PDF
        lines_title.forEach((line: string) => {doc.text(line, wid+30, pdfRow); pdfRow += lineHeight;  });
        pdfRow = pdfRow - 5;

        doc.setFont(fontname, 'bold')
        doc.text(`Created By : `, 120, firstRow);
        doc.setFont(fontname, 'normal')
        wid = doc.getTextWidth(`Created By: `);
        doc.text(`${selReport?.createdby + ""}`, wid + 130, firstRow);

        //----------------------second line and 3rd line of pdf ---------------------//

        doc.setFont(fontname, 'bold')
        doc.text(`Project         : `, 20, pdfRow + 10);
        doc.setFont(fontname, 'normal')
        wid = doc.getTextWidth(`Project           : `);
        doc.text(`${selReport?.project_name + ""}`, wid + 25, pdfRow + 10);

        doc.setFont(fontname, 'bold')
        doc.text(`Created Date : `, 120, pdfRow + 10);
        doc.setFont(fontname, 'normal')
        wid = doc.getTextWidth(`Created Date : `);
        doc.text(`${selReport?.createddate + ""}`, wid + 125, pdfRow + 10);


        doc.setFont(fontname, 'bold')
        doc.text(`Description : `, 20, pdfRow + 20);
        doc.setFont(fontname, 'normal')
        wid = doc.getTextWidth(`Description : `);
  //      doc.text(`${handleDescFormatting(selReport?.description +"") }`, wid + 30, row + 20);

        const lines = doc.splitTextToSize(selReport?.description+"", 140);
        pdfRow = pdfRow + 20; // Set starting coordinates of desc
        
        // Add each line of desc to the PDF
        lines.forEach((line: string) => { // Explicit type annotation
            doc.text(line, wid+30, pdfRow);
            pdfRow += lineHeight;
        });
    
    
        //----------------------table content of report pdf ---------------------//

        // Add report table header from columns
        const headerStartY = pdfRow ; // Adjust row height based on previous elements

        doc.setFontSize(10);
        const headers = Object.keys(rowsReportDetails[0]);
        const rowsPDF: string[][] = [];
        for (const item of rowsReportDetails) {
            if (typeof item === 'object' && !Array.isArray(item)) {
                const row = headers.map(header => (item as any)[header]);
                rowsPDF.push(row);
            }
        }

        autoTable(doc, {
            startY: headerStartY,
            head: [tableHeaders],
            body: rowsPDF,
            theme: 'grid', // Adjust theme as needed
            styles: {
                fontSize: 9},
                headStyles: {
                    fillColor: [202, 255, 89], // light green colour 
                    textColor: [0,0,0], // Set white text color for contrast
                    fontStyle: 'bold', // Set bold font for headings
                },    });

        doc.save('Report.pdf');

    }


    return (
        <ThemeProvider theme={getTheme()}>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color='inherit' />
            </Backdrop>

            <Box sx={{ position: 'relative', top: 0, right: 0, mt: '-70px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant='h6' gutterBottom>
                        <Link to={'/reports'} >Reports </Link> {ARROW} View Report
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button variant='contained' color='primary'
                            onClick={handleExportExcel}
                            sx={{ mr: 2 }}
                        >
                            Download as Excel
                        </Button>
                        <Button variant='contained' color='primary'
                            onClick={handleExportPDF}
                            sx={{ mr: 1 }}
                        >
                            Download as PDF
                        </Button>
                    </Box>
                </Box>

                <Grid container spacing={2} sx={{ mt: '30px' }}>
                    <Grid item xs={12}>
                        <Box>
                            <Grid container spacing={1}>

                                <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                                    <p><strong>Report Title</strong></p>
                                </Grid>
                                <Grid item xs={3} sx={{ mt: '10px', ml: '-30px' }}>
                                    {selReport?.title}
                                </Grid>
                                <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                                    <p><strong>Created By</strong></p>
                                </Grid>

                                <Grid item xs={3} sx={{ mt: '10px', ml: '-30px' }}>
                                    {selReport?.createdby}
                                </Grid>

                                <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                                    <p><strong>Project </strong></p>
                                </Grid>
                                <Grid item xs={3} sx={{ mt: '10px', ml: '-30px' }}>
                                    {selReport?.project_name}
                                </Grid>

                                <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                                    <p><strong>Created Date</strong></p>
                                </Grid>
                                <Grid item xs={3} sx={{ mt: '10px', ml: '-30px' }}>
                                    {selReport?.createddate}
                                </Grid>

                                <Grid item xs={3} sx={{ mt: '0px', ml: '30px' }}>
                                    <p><strong>Description</strong></p>
                                </Grid>
                                <Grid item xs={8} sx={{ mt: '10px', ml: '-30px' }}>
                                    {selReport?.description}
                                </Grid>


                            </Grid>


                            <Box sx={{ marginTop: '20px' }}>
                                <BasicTable columns={selectedColumns} rows={rowsReportDetails} />
                            </Box>

                        </Box>
                    </Grid>
                </Grid>
                <FloatingButton/>
            </Box>

        </ThemeProvider>
    )
}
export default ReportView;

